module.exports = __webpack_public_path__ + "img/aboutTab_bg1.290c3ce6.png";